import { render, staticRenderFns } from "./AbtestCurtain.vue?vue&type=template&id=9d892fc6"
import script from "./AbtestCurtain.vue?vue&type=script&lang=js"
export * from "./AbtestCurtain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports